<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/3 flex lg:mr-3 mb-4"></div>
			<div class="lg:w-2/3 flex justify-end">
				<ButtonBlack class="mr-1">
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="conf_campaigns"
			:section="section"
			:itemsTable="itemsTable"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import { queryCampaignsList } from '@/apollo/queries/admin/campaigns'

export default {
	apollo: {
		conf_campaigns: queryCampaignsList()
	},
	data() {
		return {
			search: '',
			section: 'campaign',
			itemsTable: 'conf_campaigns',
			itemsTitles: ['Id', 'Nombre', 'Pais']
		}
	},
	components: { ListTable }
}
</script>

<style scoped>
.w-24R {
	width: 24rem;
}
</style>
